import type * as React from 'react';
import styled from 'styled-components';
import type { EmbedDescriptor } from '../types';
import Airtable from './Airtable';
import Image from './components/Image';
import Figma from './Figma';
import Gist from './Gist';
import GoogleCalendar from './GoogleCalendar';
import GoogleDocs from './GoogleDocs';
import GoogleDrive from './GoogleDrive';
import GoogleSheets from './GoogleSheets';
import GoogleSlides from './GoogleSlides';
import Hex from './Hex';
import LookerStudio from './LookerStudio';
import Loom from './Loom';
import Mindmeister from './Mindmeister';
import Miro from './Miro';
import Pitch from './Pitch';
import Trello from './Trello';
import YouTube from './YouTube';

export type EmbedProps = {
	isSelected: boolean;
	isEditable: boolean;
	embed: EmbedDescriptor;
	attrs: {
		href: string;
		matches: RegExpMatchArray;
	};
};

function matcher(Component: React.ComponentType<EmbedProps>) {
	return (url: string): boolean | [] | RegExpMatchArray => {
		// @ts-expect-error TS(2339): Property 'ENABLED' does not exist on type 'Compone... Remove this comment to see the full error message
		const regexes = Component.ENABLED;

		for (const regex of regexes) {
			const result = url.match(regex);

			if (result) {
				return result;
			}
		}

		return false;
	};
}

const Img = styled(Image)`
	margin: 4px;
	width: 18px;
	height: 18px;
`;

const embeds: EmbedDescriptor[] = [
	{
		title: 'Airtable',
		keywords: 'spreadsheet',
		icon: () => <Img src="/images/airtable.webp" alt="Airtable" />,
		component: Airtable,
		matcher: matcher(Airtable),
	},
	{
		title: 'Figma',
		keywords: 'design svg vector',
		icon: () => <Img src="/images/figma.webp" alt="Figma" />,
		component: Figma,
		matcher: matcher(Figma),
	},
	{
		title: 'GitHub Gist',
		keywords: 'code',
		icon: () => <Img src="/images/github-gist.webp" alt="GitHub" />,
		component: Gist,
		matcher: matcher(Gist),
	},
	{
		title: 'Google Drive',
		keywords: 'drive',
		icon: () => <Img src="/images/google-drive.webp" alt="Google Drive" />,
		component: GoogleDrive,
		matcher: matcher(GoogleDrive),
	},
	{
		title: 'Google Docs',
		keywords: 'documents word',
		icon: () => <Img src="/images/google-docs.webp" alt="Google Docs" />,
		component: GoogleDocs,
		matcher: matcher(GoogleDocs),
	},
	{
		title: 'Google Sheets',
		keywords: 'excel spreadsheet',
		icon: () => <Img src="/images/google-sheets.webp" alt="Google Sheets" />,
		component: GoogleSheets,
		matcher: matcher(GoogleSheets),
	},
	{
		title: 'Google Slides',
		keywords: 'presentation slideshow',
		icon: () => <Img src="/images/google-slides.webp" alt="Google Slides" />,
		component: GoogleSlides,
		matcher: matcher(GoogleSlides),
	},
	{
		title: 'Google Calendar',
		keywords: 'calendar',
		icon: () => (
			<Img src="/images/google-calendar.webp" alt="Google Calendar" />
		),
		component: GoogleCalendar,
		matcher: matcher(GoogleCalendar),
	},
	{
		title: 'Hex Tech',
		keywords: 'hex tech analytics',
		icon: () => <Img src="/images/hex.webp" alt="Hex" />,
		component: Hex,
		matcher: matcher(Hex),
	},
	{
		title: 'Looker Studio',
		keywords: 'bi business intelligence',
		icon: () => <Img src="/images/looker-studio.webp" alt="Looker Studio" />,
		component: LookerStudio,
		matcher: matcher(LookerStudio),
	},
	{
		title: 'Loom',
		keywords: 'video screencast',
		icon: () => <Img src="/images/loom.webp" alt="Loom" />,
		component: Loom,
		matcher: matcher(Loom),
	},
	{
		title: 'Mindmeister',
		keywords: 'mindmap',
		icon: () => <Img src="/images/mindmeister.webp" alt="Mindmeister" />,
		component: Mindmeister,
		matcher: matcher(Mindmeister),
	},
	{
		title: 'Miro',
		keywords: 'whiteboard',
		icon: () => <Img src="/images/miro.webp" alt="Miro" />,
		component: Miro,
		matcher: matcher(Miro),
	},
	{
		title: 'Pitch',
		keywords: 'presentation',
		icon: () => <Img src="/images/pitch.webp" alt="Pitch" />,
		component: Pitch,
		matcher: matcher(Pitch),
	},
	{
		title: 'Trello',
		keywords: 'kanban',
		icon: () => <Img src="/images/trello.webp" alt="Trello" />,
		component: Trello,
		matcher: matcher(Trello),
	},
	{
		title: 'YouTube',
		keywords: 'google video',
		icon: () => <Img src="/images/youtube.webp" alt="YouTube" />,
		component: YouTube,
		matcher: matcher(YouTube),
	},
];

export default embeds;
